import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

import { KEYCODES } from '../../../app-lite/core/constants/core.keycodes.constant';

@Directive({
  selector: '[ngEnter]'
})
export class NgEnterDirective implements OnInit, OnDestroy {
  @Output('ngEnter') enter = new EventEmitter<void>();

  private keyHandler: ( event: KeyboardEvent ) => void;

  constructor ( private el: ElementRef ) {}

  ngOnInit () : void {
    this.keyHandler = ( event: KeyboardEvent ) => {
      if (event.keyCode === KEYCODES.enter) {

        this.enter.emit();

        event.preventDefault();

      }
    };

    this.el.nativeElement.addEventListener('keydown', this.keyHandler);
  }

  ngOnDestroy () : void {


    this.el.nativeElement.removeEventListener('keydown', this.keyHandler);


    };


  }
